import { object } from "../helpers/object";
import { debug } from "../helpers/debug";

/*------------------------------------*\
  #IMAGE360

  Class gestion des element [data-js-component="image-360"]
\*------------------------------------*/
class Image360 {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    window.CI360.init();
    if(debug.DEBUG) console.log('async/image-360.js');
  }
}
export default new Image360('[data-js-component="image-360"]'); 